import { render, staticRenderFns } from "./IconDownload.vue?vue&type=template&id=25730022&scoped=true&functional=true&"
import script from "./IconDownload.vue?vue&type=script&lang=ts&"
export * from "./IconDownload.vue?vue&type=script&lang=ts&"
import style0 from "./IconDownload.vue?vue&type=style&index=0&id=25730022&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "25730022",
  null
  
)

export default component.exports